module.exports = {
  "calendar": "Napt\xE1r",
  "day": "nap",
  "dayPeriod": "napszak",
  "endDate": "Befejez\u0151 d\xE1tum",
  "era": "\xE9ra",
  "hour": "\xF3ra",
  "minute": "perc",
  "month": "h\xF3nap",
  "second": "m\xE1sodperc",
  "selectedDateDescription": function selectedDateDescription(args) {
    return "Kijel\xF6lt d\xE1tum: ".concat(args.date);
  },
  "selectedRangeDescription": function selectedRangeDescription(args) {
    return "Kijel\xF6lt tartom\xE1ny: ".concat(args.startDate, "\u2013").concat(args.endDate);
  },
  "selectedTimeDescription": function selectedTimeDescription(args) {
    return "Kijel\xF6lt id\u0151: ".concat(args.time);
  },
  "startDate": "Kezd\u0151 d\xE1tum",
  "timeZoneName": "id\u0151z\xF3na",
  "weekday": "h\xE9t napja",
  "year": "\xE9v"
};